/*
  カートページ上でのクーポン適用制御

  ご購入手続きへボタンをクリックした際に、クーポンが選択されていればクーポン適用処理を行う
*/
const loadCouponList = () => {
  // Modal表示
  const couponListModalContents = document.getElementById(
      "coupon-list-contents"
    ),
    couponListModal = document.getElementById("coupon-list-modal");
  if (couponListModalContents) {
    couponListModal.innerHTML = couponListModalContents.innerHTML;
    couponListModalContents.innerHTML = "";

    const openModalBtn = document.getElementById("show-coupon-list-modal");
    const modal = document.getElementById("coupon-list-modal");
    const closeBtn = document.getElementById("close-coupon-list-modal");
    const modalBackground = document.getElementById("bg-coupon-list-modal");

    if (openModalBtn) {
      openModalBtn.onclick = function () {
        modal.classList.add("show");
        setTimeout(() => {
          modal.style.display = "block";
        }, 10);
      };
    }

    if (closeBtn) {
      closeBtn.onclick = function () {
        modal.classList.remove("show");
        setTimeout(() => {
          modal.style.display = "none";
        }, 500);
      };
    }

    if (modalBackground) {
      modalBackground.onclick = function () {
        modal.classList.remove("show");
        setTimeout(() => {
          modal.style.display = "none";
        }, 500);
      };
    }
  } else {
    couponListModal.innerHTML = "";
  }

  // クーポン適用処理
  const applyCouponButtonList = document.querySelectorAll(
      "[data-apply-coupon-code]"
    ),
    checkoutBtn = document.querySelector('[name="checkout"]'),
    nameDiscount = document.querySelector('[name="discount"]'),
    couponCheckboxList = document.querySelectorAll("[data-coupon-checkbox]");

  // クーポン選択時、valueが同じ他のチェックボックスも同時にチェックする(使えるクーポン用)
  couponCheckboxList.forEach(function (couponCheckbox) {
    couponCheckbox.addEventListener("change", function (e) {
      const otherCheckbox = document.querySelector(
        `[data-coupon-checkbox][value="${e.target.value}"]:not(#${e.target.id})`
      );
      if (otherCheckbox) {
        otherCheckbox.checked = e.target.checked;
      }

      // クーポンが5つ選択された場合、それ以上選択できないようにする
      const checkedCouponList = document.querySelectorAll(
        "[data-coupon-checkbox]:not([data-max-coupon]):checked"
      );
      if (checkedCouponList.length >= 5) {
        couponCheckboxList.forEach(function (checkbox) {
          if (!checkbox.checked) {
            checkbox.setAttribute("disabled", true);
          }
        });
      } else {
        couponCheckboxList.forEach(function (checkbox) {
          checkbox.removeAttribute("disabled");
        });
      }
    });
  });
  if (document.querySelector("[data-max-coupon]")) {
    document
      .querySelector("[data-max-coupon]")
      .dispatchEvent(new Event("change"));
  }

  if (applyCouponButtonList.length > 0 && nameDiscount) {
    // クーポン選択時、form内にクーポンコードを設定
    applyCouponButtonList.forEach(function (applyCouponButton) {
      applyCouponButton.addEventListener("click", function () {
        // 出荷倉庫の同梱制御でブロック中は決済へ進ませない。
        // disabled 済みならクリック自体発火しないが、アプリ/拡張が属性を剥がした場合の保険。
        // 下の form.loading 付与より前に return すること（後だとフォームが loading のまま固まる）
        if (applyCouponButton.hasAttribute("data-checkout-blocked")) return;

        applyCouponButton.setAttribute("disabled", true);
        const checkedCouponList = document.querySelectorAll(
          "[data-coupon-checkbox]:checked"
        );

        let couponCode = "";
        if (checkedCouponList.length > 0) {
          checkedCouponList.forEach(function (checkedCoupon, idx) {
            if (idx === 0) {
              couponCode += checkedCoupon.value;
            } else {
              couponCode += "," + checkedCoupon.value;
            }
          });
        }
        nameDiscount.value = couponCode;

        document.querySelector("form.cart").classList.add("loading");

        if (couponCode) {
          window.location.href = `/checkout?discount=${encodeURIComponent(
            couponCode
          )}`;
        } else {
          checkoutBtn.click();
        }
      });
    });
  }
};

// load(全リソース読込完了)待ちだと重いページで「ご購入手続きへ」が数十秒間無反応になるため、
// DOM構築済みの時点で即バインドする（speed-kaizen 2026-06）
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", loadCouponList);
} else {
  loadCouponList();
}

// iOS Safari等のBFCache復元時、クリック済みボタンが disabled / form.loading のまま固定され
// 二度と押せなくなるのを防ぐ（チェックアウトから戻った場合の復帰, speed-kaizen 2026-06）
window.addEventListener("pageshow", (event) => {
  if (!event.persisted) return;
  // 出荷倉庫の同梱制御でブロック中のボタンは復帰対象から除外する（再活性化させない）
  document
    .querySelectorAll("[data-apply-coupon-code]:not([data-checkout-blocked])")
    .forEach((btn) => btn.removeAttribute("disabled"));
  const cartForm = document.querySelector("form.cart");
  if (cartForm) cartForm.classList.remove("loading");
});

/*
  出荷倉庫（custom.warehouse）の同梱制御を最新のカート状態へ同期する。

  判定は Liquid（sections/cart-template.liquid）が行い、JS側は結果を受け取るだけ。
  Ajax Cart API は商品メタフィールドを返さないため、JSで倉庫を再判定してはいけない。

  [name=checkout] と警告メッセージは .cart-coupon-list の外にあるため明示的に同期する。
  クーポンボタンと動的チェックアウトは .cart-coupon-list の差し替えで
  Liquid が描画した状態が入るため、ここでの処理は冗長な保険。
*/
const syncWarehouseCheckoutState = (freshRoot) => {
  const freshGate = freshRoot.querySelector("[data-cart-checkout-gate]");
  const liveGate = document.querySelector("[data-cart-checkout-gate]");
  if (!freshGate || !liveGate) return;

  const blocked = freshGate.getAttribute("data-warehouse-mismatch") === "true";
  liveGate.setAttribute("data-warehouse-mismatch", String(blocked));

  // 警告メッセージの表示・非表示
  document
    .querySelector("[data-warehouse-alert]")
    ?.classList.toggle("hide", !blocked);

  // 決済ボタン群。クーポン一覧モーダルのボタンはセクション外へ移動済みのため document 全体を対象にする
  document
    .querySelectorAll('[name="checkout"], [data-apply-coupon-code]')
    .forEach((button) => {
      if (blocked) {
        button.setAttribute("disabled", true);
        button.setAttribute("aria-disabled", "true");
        button.setAttribute("data-checkout-blocked", "warehouse");
        return;
      }
      // 倉庫制御が付けた属性だけを外す。無条件に外すとクリック時に付与された
      // disabled まで剥がしてしまい、遷移中のボタンが再度押せてしまう
      if (button.getAttribute("data-checkout-blocked") !== "warehouse") return;
      button.removeAttribute("disabled");
      button.removeAttribute("aria-disabled");
      button.removeAttribute("data-checkout-blocked");
    });
};

// 倉庫制御中は数量欄でのEnter等による暗黙のフォーム送信も止める
document.addEventListener("submit", (event) => {
  const cartForm = event.target.closest?.("form.cart");
  if (!cartForm) return;
  if (
    document.querySelector(
      '[data-cart-checkout-gate][data-warehouse-mismatch="true"]'
    )
  ) {
    event.preventDefault();
  }
});

// カート更新時の再レンダリング
const updateCartCouponList = (_updateCartTemplate) => {
  const updateCartTemplate = document.createElement("div");
  updateCartTemplate.innerHTML = _updateCartTemplate;

  // 送料セクション（配送料の行・送料無料バー）は theme.js の数量変更AJAX部分更新の対象外で
  // 初期表示のまま固着するため、再描画済みHTMLから該当区画を差し替えて最新化する（speed-kaizen 2026-06）
  [".cart-shipping", ".js-cart-free-ship"].forEach((selector) => {
    const fresh = updateCartTemplate.querySelector(selector);
    const live = document.querySelector(selector);
    if (fresh && live) live.innerHTML = fresh.innerHTML;
  });

  const updateCouponList =
    updateCartTemplate.querySelector(".cart-coupon-list");
  // 購入不可状態（予約商品混在・Line Item上限など）ではライブ側に .cart-coupon-list が
  // 存在しないため、両方を確認してから差し替える
  const currentCouponList = document.querySelector(".cart-coupon-list");

  if (updateCouponList && currentCouponList) {
    currentCouponList.innerHTML = updateCouponList.innerHTML;
    loadCouponList();

    // クーポン選択状態の最新化
    const currentCouponValue =
      document.querySelector('[name="discount"]')?.value || "";
    document
      .querySelectorAll("[data-coupon-checkbox]")
      .forEach(function (checkbox) {
        if (currentCouponValue.includes(checkbox.value)) {
          checkbox.checked = true;
        } else {
          checkbox.checked = false;
        }
      });
  }

  // 差し替え後の状態へ倉庫制御を同期する（必ず最後に実行すること）
  syncWarehouseCheckoutState(updateCartTemplate);
};
